import CardDetailPopover from '@/components/sider/Dialog/cardDetailPopover';
import { Box, Typography } from '@mui/material';
import React from 'react';

function ArchiveSourceComponent({
  value,
  cardData,
  handleOnMouseLeaveRemove,
  popupElements,
}: {
  value: string;
  cardData: any;
  handleOnMouseLeaveRemove: Function;
  popupElements?: any;
}): React.ReactElement {
  return (
    <Box className="d-flex align-items-center">
      <Typography
        variant="caption"
        className="truncate"
        aria-label="card-data-src"
        sx={{
          maxWidth: 145,
        }}
        display="block"
      >
        {value}
        {/* {cardData.source} */}
      </Typography>
      <CardDetailPopover
        handleOnMouseLeaveRemove={handleOnMouseLeaveRemove}
        cardData={cardData}
        popupElements={popupElements}
      />
    </Box>
  );
}

export default ArchiveSourceComponent;
